import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	title: string;
};

export const FlatRowSectionTitle: FC<Props> = ({ title }) => {
	const { spacingTokens } = useTheme();

	return (
		<Typography
			variant="overline"
			display="block"
			pt={2.4}
			px={spacingTokens.lg}
			pb={spacingTokens.sm}
		>
			{title}
		</Typography>
	);
};
